export default __webpack_public_path__ + "static/media/drop.14074c83.png";